require('./searchMenuController');

"use strict";

angular.module('app.mainFrame.searchMenu.searchMenuDirective', [
    'app.mainFrame.searchMenu.searchMenuController'
])
    .directive('searchMenu', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/mainFrame/searchMenu/searchMenuView.html',
                controller: 'app.mainFrame.searchMenu.searchMenuController',
                link: function (scope, elm) {
                    elm.addClass('search-menu');
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/searchMenu/searchMenuDirective.js